import React, { useState, useEffect } from "react";
import axios from "../../api/axiosConfig";
import Swal from "sweetalert2";
import "../../print.css";
import QRCode from "qrcode.react";
import logo from "../../images/LogoTransparente.png";

const NotaVentaView = () => {
  const [NotaVenta, setNotaVenta] = useState(null);
  const [Graduaciones, setGraduaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [verGraduacion, setVerGraduacion] = useState("none");
  const [verPrecios, setVerPrecios] = useState("none");
  const [UltimaTransaccion, setUltimaTransaccion] = useState(null);

  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const id = params.get("id");
  const tipoNota = params.get("tipoNota");
  const EsVisita = params.get("visita");
  const idVisita = params.get("idVisita");
  const [qrLink, setQrLink] = useState("");

  useEffect(() => {
    //Aqui vamos a modificar el formato de salida del pdf dependiendo que tipo de nota queremos imprimir al momento.
    switch(tipoNota) {
      case "0": { //Cliente con todos los datos pero sin graduacion.
        setVerGraduacion("none");
        setVerPrecios("flex");
        break;
      }
      case "1": { // Administrador con todos los datos
        setVerGraduacion("block");
        setVerPrecios("flex");
        break;
      }
      case "2": { //Laboratorio con todos los datos menos los precios
        setVerGraduacion("block");
        setVerPrecios("none");
        break;
      }
      case "3": { //Extra Personal 
        setVerGraduacion("None");
        setVerPrecios("none");
        break;
      }
      default: {
        setVerGraduacion("block");
        setVerPrecios("flex");
        break;
      }
    }
  }, [tipoNota]);

  useEffect(() => {
    document.body.style.paddingTop = "0";
    const fetchUltimaNotaVenta = async () => {
      try {
        console.log("Fetching data - EsVisita:", EsVisita, "id:", id, "idVisita:", idVisita);
        // Si es una visita con idVisita específico, cargar solo datos de visita
        if (EsVisita === "true" && idVisita) {
          // Cargar solo datos de visita (sin pedido enlazado)
          const response = await axios.get(
            `/visitas/porId/${idVisita}`
          );
          if (response.data.success && response.data.data) {
            const visitaData = response.data.data;
            console.log("Visita data recibida:", visitaData);
            // Asegurar que los datos de sucursal estén disponibles
            const notaVentaData = {
              ...visitaData,
              nombreCliente: visitaData.nombreCliente || visitaData.NombreCliente,
              telefono: visitaData.telefono,
              direccionSucursal: visitaData.direccionSucursal || visitaData.NombreSucursal,
              rfc: visitaData.rfc,
              razonSocial: visitaData.razonSocial,
              tipoTicketFis: "Nota Simple", // Para visitas independientes
            };
            console.log("NotaVentaData configurado:", notaVentaData);
            setNotaVenta(notaVentaData);
            // Para una visita independiente, usar los datos directamente de la visita
            // Convertir la visita en formato de graduación para mostrarla
            const graduacionFromVisita = {
              EsfOd: visitaData.EsfOd || visitaData.esfOd,
              EsfOi: visitaData.EsfOi || visitaData.esfOi,
              CilOd: visitaData.CilOd || visitaData.cilOd,
              CilOi: visitaData.CilOi || visitaData.cilOi,
              EjeOd: visitaData.EjeOd || visitaData.ejeOd,
              EjeOi: visitaData.EjeOi || visitaData.ejeOi,
              AddOd: visitaData.AddOd || visitaData.addOd,
              AddOi: visitaData.AddOi || visitaData.addOi,
              RetinosOd: visitaData.RetinosOd || visitaData.retinosOd,
              RetinosOi: visitaData.RetinosOi || visitaData.retinosOi,
              QueratoOd1: visitaData.QueratoOd1 || visitaData.queratoOd1,
              QueratoOd2: visitaData.QueratoOd2 || visitaData.queratoOd2,
              QueratoOd3: visitaData.QueratoOd3 || visitaData.queratoOd3,
              QueratoOi1: visitaData.QueratoOi1 || visitaData.queratoOi1,
              QueratoOi2: visitaData.QueratoOi2 || visitaData.queratoOi2,
              QueratoOi3: visitaData.QueratoOi3 || visitaData.queratoOi3,
              color: visitaData.Color || visitaData.color,
              lenteContactoDes: visitaData.LenteContactoDes || visitaData.lenteContactoDes,
              Observaciones: visitaData.Observaciones || visitaData.observaciones,
              AvOd: visitaData.AvOd || visitaData.avOd,
              AvOi: visitaData.AvOi || visitaData.avOi,
              CvOd: visitaData.CvOd || visitaData.cvOd,
              CvOi: visitaData.CvOi || visitaData.cvOi,
              DiData: visitaData.DiData || visitaData.diData,
              AoData: visitaData.AoData || visitaData.aoData,
            };
            setGraduaciones([graduacionFromVisita]);
            // No establecer QR link para visitas independientes sin pedido
            setQrLink(""); 
            setLoading(false);
          } else {
            console.log("No se encontró la visita con idVisita:", idVisita);
            setLoading(false);
          }
        } else {
          // Cargar pedido normal (con o sin parámetro visita, pero sin idVisita específico)
          // El id aquí es el ID del pedido
          const response = await axios.get(
            `/pedidoCompletoPorId/${id}`
          );
          if (response.data && response.data[0]) {
            const pedidoData = response.data[0];
            // Asegurar que tipoTicketFis esté correctamente establecido
            // Normalizar el valor (trim y verificar)
            const tipoTicketFisNormalizado = pedidoData.tipoTicketFis ? pedidoData.tipoTicketFis.trim() : "";
            // Solo establecer "Nota Simple" si el valor está vacío/null Y no hay facturación
            // Si ya tiene un valor (como "Comprobante"), respetarlo
            if ((!tipoTicketFisNormalizado || tipoTicketFisNormalizado === "") && 
                (pedidoData.facturacion === "False" || pedidoData.facturacion === false || 
                 pedidoData.facturacion === "false" || !pedidoData.facturacion)) {
              pedidoData.tipoTicketFis = "Nota Simple";
            } else if (tipoTicketFisNormalizado) {
              // Asegurar que el valor esté normalizado (mantener "Comprobante" si ya lo es)
              pedidoData.tipoTicketFis = tipoTicketFisNormalizado;
            }
            console.log("tipoTicketFis establecido:", pedidoData.tipoTicketFis, "facturacion:", pedidoData.facturacion, "rfc:", pedidoData.rfc);
            setNotaVenta(pedidoData);
            if (pedidoData.tipoPago === "Anticipo") {
              axios.get(`/transaccion/${pedidoData.pedido_id}`).then((response)=>{
                setUltimaTransaccion(response.data.data[0]);
              }).catch((err) =>{console.error(err);});;
            }
            pedidoData.formaPago == "Debito" ? pedidoData.formaPago = "Débito" : pedidoData.formaPago == "Credito" ? pedidoData.formaPago = "Crédito" : pedidoData.formaPago;

            // Si el pedido está ligado a una visita específica, usar los datos de esa visita
            // en lugar de la última graduación del cliente
            if (pedidoData.IdVisita) {
              console.log("Pedido ligado a visita IdVisita:", pedidoData.IdVisita);
              try {
                const visitaResponse = await axios.get(
                  `/visitas/porId/${pedidoData.IdVisita}`
                );
                if (visitaResponse.data.success && visitaResponse.data.data) {
                  const visitaData = visitaResponse.data.data;
                  // Convertir la visita en formato de graduación para mostrarla
                  const graduacionFromVisita = {
                    EsfOd: visitaData.EsfOd || visitaData.esfOd,
                    EsfOi: visitaData.EsfOi || visitaData.esfOi,
                    CilOd: visitaData.CilOd || visitaData.cilOd,
                    CilOi: visitaData.CilOi || visitaData.cilOi,
                    EjeOd: visitaData.EjeOd || visitaData.ejeOd,
                    EjeOi: visitaData.EjeOi || visitaData.ejeOi,
                    AddOd: visitaData.AddOd || visitaData.addOd,
                    AddOi: visitaData.AddOi || visitaData.addOi,
                    RetinosOd: visitaData.RetinosOd || visitaData.retinosOd,
                    RetinosOi: visitaData.RetinosOi || visitaData.retinosOi,
                    QueratoOd1: visitaData.QueratoOd1 || visitaData.queratoOd1,
                    QueratoOd2: visitaData.QueratoOd2 || visitaData.queratoOd2,
                    QueratoOd3: visitaData.QueratoOd3 || visitaData.queratoOd3,
                    QueratoOi1: visitaData.QueratoOi1 || visitaData.queratoOi1,
                    QueratoOi2: visitaData.QueratoOi2 || visitaData.queratoOi2,
                    QueratoOi3: visitaData.QueratoOi3 || visitaData.queratoOi3,
                    color: visitaData.Color || visitaData.color,
                    lenteContactoDes: visitaData.LenteContactoDes || visitaData.lenteContactoDes,
                    Observaciones: visitaData.Observaciones || visitaData.observaciones,
                    AvOd: visitaData.AvOd || visitaData.avOd,
                    AvOi: visitaData.AvOi || visitaData.avOi,
                    CvOd: visitaData.CvOd || visitaData.cvOd,
                    CvOi: visitaData.CvOi || visitaData.cvOi,
                    DiData: visitaData.DiData || visitaData.diData,
                    AoData: visitaData.AoData || visitaData.aoData,
                    Optometrista: visitaData.Optometrista || visitaData.optometrista,
                    Cedula: visitaData.Cedula || visitaData.cedula,
                    NombreIdentificador: visitaData.NombreIdentificador || visitaData.nombreIdentificador,
                  };
                  setGraduaciones([graduacionFromVisita]);
                  console.log("Graduación cargada desde visita ligada:", graduacionFromVisita);
                } else {
                  // Si no se puede cargar la visita, usar la última graduación del cliente como fallback
                  console.warn("No se pudo cargar la visita ligada, usando última graduación del cliente");
                  const dataGraduacion = await axios.get(
                    `/LeerGraduaciones/${pedidoData.idCliente}`
                  );
                  setGraduaciones(dataGraduacion.data);
                }
              } catch (error) {
                console.error("Error al cargar la visita ligada:", error);
                // Si hay error, usar la última graduación del cliente como fallback
                const dataGraduacion = await axios.get(
                  `/LeerGraduaciones/${pedidoData.idCliente}`
                );
                setGraduaciones(dataGraduacion.data);
              }
            } else {
              // Si no hay visita ligada, usar la última graduación del cliente (comportamiento original)
              console.log("Pedido sin visita ligada, usando última graduación del cliente");
              const dataGraduacion = await axios.get(
                `/LeerGraduaciones/${pedidoData.idCliente}`
              );
              setGraduaciones(dataGraduacion.data);
            }
            setQrLink(`${window.origin}/=` + pedidoData.HashId); 
          }
          setLoading(false);
        }

        
        
      } catch (error) {
        console.error("Error al obtener el ultimo pedido:", error);
        Swal.fire({
          icon: "warning",
          title: "Error al obtener el ultimo pedido",
          text: "Hubo un problema al cargar los detalles de el ultimo pedido. Por favor, inténtalo de nuevo más tarde.",
        });
        setLoading(false);
      }
    };
    
    if (id) {
      fetchUltimaNotaVenta();
    } else {
      setLoading(false);
    }
  }, [id, EsVisita, idVisita]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return date.toLocaleDateString("es-ES", options);
  };

  const formatDateWithoutTime = (dateString) => {
    const formattedDate = formatDate(dateString);
    return formattedDate.split(",")[0];
  };

  function formatNumber(number) {
    number = parseInt(number);
    const [integerPart, decimalPart] = number.toFixed(2).split(".");
    const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${integerWithCommas}.${decimalPart}`;
  }

  function capitalize(text) {
    if (!text) return text; 
    return text
      .toLowerCase() 
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
      .join(' '); 
  }

  const fecha = new Date();

  // Definir las opciones de formato para el día, mes y año
  const opciones = { day: 'numeric', month: 'numeric', year: 'numeric' };

  // Formatear la fecha
  const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones);

  // Solo procesar fechaEntregaPrevista si NotaVenta existe y tiene esa propiedad (no es una visita)
  const fechaEntregaPrevista = NotaVenta && NotaVenta.fechaEntregaPrevista ? new Date(NotaVenta.fechaEntregaPrevista) : null;

  function formatearFecha() {
    if (!fechaEntregaPrevista) return "";
    // Arreglos para días y meses
    const dias = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
    const meses = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
  
    // Obtener el día y el mes de la fecha
    const dia = dias[fechaEntregaPrevista.getDay()];
    const mes = meses[fechaEntregaPrevista.getMonth()];
  
    // Formatear y devolver la fecha
    return `${dia} ${fechaEntregaPrevista.getDate()} de ${mes} de ${fechaEntregaPrevista.getFullYear()}`;
  }
  
  // Formatear la fecha
  //const fechaFormateadaEntrega = fechaEntregaPrevista.toLocaleDateString('es-ES', opciones);
  const fechaFormateadaEntrega = fechaEntregaPrevista ? formatearFecha() : "";

  // Si está cargando, mostrar mensaje de carga
  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <p>Cargando...</p>
      </div>
    );
  }

  // Si no está cargando pero no hay NotaVenta, mostrar mensaje de error
  if (!NotaVenta) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <p>No se encontraron datos para mostrar.</p>
      </div>
    );
  }

  return (
    <div style={{fontSize: "11.5px", width: '70mm', position: 'relative', fontFamily: 'Arial, sans-serif', fontWeight: '800', padding: '2mm'}} id="content">
      {EsVisita === "true" ? (
         <div style={{ fontSize: "12px", width: '100%', position: 'relative', fontFamily: 'Arial, sans-serif', fontWeight: '800' }} id="content">
         {/* Header */}
         <div style={{ textAlign: "center", marginBottom: "8px", fontWeight: 'bold', fontSize: '13px', borderBottom: '1px solid #000', paddingBottom: '5px' }}>
           <strong>{NotaVenta && NotaVenta.tipoTicketFis && NotaVenta.tipoTicketFis.trim() === "Nota Simple" ? "Nota de Venta" : "Comprobante"}</strong>
         </div>
         <div style={{ display: 'flex', width: '100%', marginBottom: "8px", justifyContent: 'center' }}>
           <img src={logo} style={{ width: "110px", height: 'auto' }} />
         </div>
         
         {/* Información Fiscal y Sucursal */}
         <div style={{ marginBottom: "8px", borderBottom: '1px dashed #ccc', paddingBottom: '6px' }}>
           <div style={{ marginBottom: "3px", textAlign: 'center', fontSize: '11px' }}>
             <strong>Fecha:</strong> {fechaFormateada}
           </div>
           {NotaVenta && NotaVenta.tipoTicketFis && NotaVenta.tipoTicketFis.trim() !== "Nota Simple" && (
             <>
               {NotaVenta.rfc && (
                 <div style={{ marginBottom: "2px", textAlign: 'center', fontSize: '9px' }}>
                   <strong>RFC:</strong> {NotaVenta.rfc}
                 </div>
               )}
               {NotaVenta.razonSocial && (
                 <div style={{ marginBottom: "3px", textAlign: 'center', fontSize: '9px', fontWeight: '700' }}>
                   {NotaVenta.razonSocial.toUpperCase()}
                 </div>
               )}
             </>
           )}
           {(NotaVenta.direccionSucursal || NotaVenta.NombreSucursal) && (
             <div style={{ marginBottom: "0px", textAlign: 'center', padding: '0 1mm', fontSize: '9px', lineHeight: '1.2' }}>
               {NotaVenta.direccionSucursal || NotaVenta.NombreSucursal}
             </div>
           )}
         </div>

         {/* Información del Cliente */}
         <div style={{ marginBottom: "8px", borderBottom: '1px dashed #ccc', paddingBottom: '6px' }}>
           <div style={{ marginBottom: "3px", textAlign: 'center', fontSize: '11px', fontWeight: 'bold' }}>
             <strong>Cliente:</strong> {NotaVenta.NombreCliente || NotaVenta.nombreCliente}
           </div>
           {NotaVenta.telefono && (
             <div style={{ marginBottom: "0px", textAlign: 'center', fontSize: '10px' }}>
               <strong>Tel:</strong> {NotaVenta.telefono}
             </div>
           )}
           {NotaVenta.NombreIdentificador && (
             <div style={{ marginTop: "4px", marginBottom: "0px", textAlign: 'center', fontSize: '11px', fontWeight: 'bold', padding: '2px', backgroundColor: '#f0f0f0', borderRadius: '3px' }}>
               <strong>ID:</strong> {NotaVenta.NombreIdentificador}
             </div>
           )}
           {NotaVenta.Optometrista && (
             <div style={{ marginTop: "4px", marginBottom: "0px", textAlign: 'center', fontSize: '10px' }}>
               <strong>Optometrista:</strong> {NotaVenta.Optometrista}
               {NotaVenta.Cedula && <span style={{ fontSize: '9px' }}> - Cédula: {NotaVenta.Cedula}</span>}
             </div>
           )}
         </div>
         {Graduaciones.length > 0 ? (
          Graduaciones.map((Graduacion, index) => (
            <div style={{ marginTop: "8px", display: verGraduacion, marginBottom: '12px', borderTop: '1px solid #000', paddingTop: '8px'}} key={index}>
              <div style={{ textAlign: "center", marginBottom: "6px", fontSize: '12px', fontWeight: 'bold' }}>
                <strong style={{textDecoration: 'underline'}}>Datos de Optometría {Graduaciones.length > 1 ? index + 1 : ''}</strong>
              </div>
              <div style={{textAlign: "center", marginBottom: "4px", fontSize: '11px', fontWeight: 'bold'}}>
                <strong>Graduación</strong>
              </div>
              <table style={{ width: '95%', margin: '0 auto', fontSize: '11px', fontWeight: '900', textAlign: 'center', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ textAlign: 'center', fontWeight: '800' }}>ESF</th>
                    <th style={{ textAlign: 'center', fontWeight: '800'  }}>CIL</th>
                    <th style={{ textAlign: 'center', fontWeight: '800'  }}>EJE</th>
                    <th style={{ textAlign: 'center', fontWeight: '800'  }}>ADD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ fontWeight: '800' }}>OD</td>
                    <td style={{border: '1px solid black'}}>{Graduacion.EsfOd > 0 ? "+" + Graduacion.EsfOd : Graduacion.EsfOd}</td>
                    <td style={{border: '1px solid black'}}>{Graduacion.CilOd > 0 ? "+" + Graduacion.CilOd : Graduacion.CilOd}</td>
                    <td style={{border: '1px solid black'}}>{Graduacion.EjeOd > 0 ? "+" + Graduacion.EjeOd : Graduacion.EjeOd}</td>
                    <td style={{border: '1px solid black'}}>{Graduacion.AddOd > 0 ? "+" + Graduacion.AddOd : Graduacion.AddOd}</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: '800' }}>OI</td>
                    <td style={{border: '1px solid black'}}>{Graduacion.EsfOi > 0 ? "+" + Graduacion.EsfOi : Graduacion.EsfOi}</td>
                    <td style={{border: '1px solid black'}}>{Graduacion.CilOi > 0 ? "+" + Graduacion.CilOi : Graduacion.CilOi}</td>
                    <td style={{border: '1px solid black'}}>{Graduacion.EjeOi > 0 ? "+" + Graduacion.EjeOi : Graduacion.EjeOi}</td>
                    <td style={{border: '1px solid black'}}>{Graduacion.AddOi > 0 ? "+" + Graduacion.AddOi : Graduacion.AddOi}</td>
                  </tr>
                </tbody>
              </table>
              {/*Si existe Retinoscopia mostramos*/}
              {
                Graduacion.RetinosOd || Graduacion.RetinosOi ? (
                  <div>
                    <div style={{ textAlign: "center", marginTop: "10px", width: '90%', justifyContent: 'center' }}>
                      <strong style={{ marginLeft: '30px', fontWeight: '800' }}>Retinoscopia</strong>
                    </div>
                    <table style={{ width: '80%', margin: '0 auto', fontSize: '13px', fontWeight: '800', borderCollapse: 'collapse', marginTop: '2px' }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center', border: '1px solid black', fontWeight: '800' }}>OD</th>
                          <th style={{ textAlign: 'center', border: '1px solid black', fontWeight: '800' }}>OI</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: 'center', border: '1px solid black' }}>{Graduacion.RetinosOd > 0 ? "+" + Graduacion.RetinosOd : Graduacion.RetinosOd}</td>
                          <td style={{ textAlign: 'center', border: '1px solid black' }}>{Graduacion.RetinosOi > 0 ? "+" + Graduacion.RetinosOi : Graduacion.RetinosOi}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ): null
              }


              {/*Si existe Queratometria mostramos*/}
              {
                Graduacion.QueratoOd1 || Graduacion.QueratoOd2 ||  Graduacion.QueratoOd3 || Graduacion.QueratoOi1 || Graduacion.QueratoOi2 || Graduacion.QueratoOi3 ? (
                  <div>
                    <div style={{ textAlign: "center", marginTop: "10px", width: '90%', justifyContent: 'center' }}>
                      <strong style={{ marginLeft: '30px', fontWeight: '800' }}>Queratometría</strong>
                    </div>
                    <table style={{ width: '80%', margin: '2px auto', fontSize: '13px', fontWeight: '800', borderCollapse: 'collapse' }} className="tablaQuerato">
                      <tbody>
                        <tr>
                          <td style={{ fontWeight: '800', textAlign: 'center', border: '1px solid black' }}>OD</td>
                          <td style={{ textAlign: 'right', border: '1px solid black', borderRightColor: 'transparent' }}>{Graduacion.QueratoOd1 > 0 ? "+" + Graduacion.QueratoOd1 : Graduacion.QueratoOd1} /</td>
                          <td style={{ textAlign: 'center', border: '1px solid black', borderRightColor: 'transparent'}}>{Graduacion.QueratoOd2 > 0 ? "+" + Graduacion.QueratoOd2 : Graduacion.QueratoOd2}</td>
                          <td style={{ textAlign: 'center', border: '1px solid black', borderRightColor: 'transparent' }}><strong>X</strong></td>
                          <td style={{ textAlign: 'center', border: '1px solid black', borderLeftColor: 'transparent' }}>{Graduacion.QueratoOd3 > 0 ? "+" + Graduacion.QueratoOd3 : Graduacion.QueratoOd3}</td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: '800', textAlign: 'center', border: '1px solid black' }}>OI</td>
                          <td style={{ textAlign: 'right', border: '1px solid black', borderRightColor: 'transparent' }}>{Graduacion.QueratoOi1 > 0 ? "+" + Graduacion.QueratoOi1 : Graduacion.QueratoOi1} /</td>
                          <td style={{ textAlign: 'center', border: '1px solid black', borderRightColor: 'transparent' }}>{Graduacion.QueratoOi2 > 0 ? "+" + Graduacion.QueratoOi2 : Graduacion.QueratoOi2}</td>
                          <td style={{ textAlign: 'center', border: '1px solid black', borderRightColor: 'transparent' }}><strong>X</strong></td>
                          <td style={{ textAlign: 'center', border: '1px solid black', borderLeftColor: 'transparent'  }}>{Graduacion.QueratoOi3 > 0 ? "+" + Graduacion.QueratoOi3 : Graduacion.QueratoOi3}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ): null
              }

              {/* Información Adicional */}
              <div style={{ marginTop: "6px", fontSize: '10px' }}>
                {Graduacion.color && (
                  <div style={{ marginBottom: "3px", textAlign: 'center' }}>
                    <strong>Dep. / Emp:</strong> {Graduacion.color}
                  </div>
                )}
                {Graduacion.lenteContactoDes && (
                  <div style={{ marginBottom: "3px", textAlign: 'center' }}>
                    <strong>Lente Contacto:</strong> {Graduacion.lenteContactoDes}
                  </div>
                )}
              </div>
              
              {/* Observaciones */}
              {(Graduacion.Observaciones || Graduacion.observaciones) && (
                <div style={{ marginTop: "6px", borderTop: '1px dashed #ccc', paddingTop: '4px' }}>
                  <div style={{ marginBottom: "2px", textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                    <strong>Observaciones:</strong>
                  </div>
                  <div style={{ marginBottom: "6px", width: '95%', textAlign: 'center', margin: '0 auto', fontSize: '10px', lineHeight: '1.3' }}>
                    {Graduacion.Observaciones || Graduacion.observaciones}
                  </div>
                </div>
              )}
              
              {/* Mostrar Agudeza Visual si existe */}
              {(Graduacion.AvOd || Graduacion.AvOi || Graduacion.CvOd || Graduacion.CvOi || Graduacion.avOd || Graduacion.avOi || Graduacion.cvOd || Graduacion.cvOi) && (
                <div style={{ marginTop: "6px" }}>
                  <div style={{ textAlign: "center", marginBottom: "3px", fontSize: '11px', fontWeight: 'bold' }}>
                    <strong>Agudeza Visual</strong>
                  </div>
                  <table style={{ width: '70%', margin: '0 auto', fontSize: '11px', fontWeight: '800', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'center', border: '1px solid #000', fontWeight: '800', padding: '2px', backgroundColor: '#f0f0f0', fontSize: '10px' }}>Ojo</th>
                        <th style={{ textAlign: 'center', border: '1px solid #000', fontWeight: '800', padding: '2px', backgroundColor: '#f0f0f0', fontSize: '10px' }}>A/V (20/)</th>
                        <th style={{ textAlign: 'center', border: '1px solid #000', fontWeight: '800', padding: '2px', backgroundColor: '#f0f0f0', fontSize: '10px' }}>C/V (20/)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ fontWeight: '800', textAlign: 'center', border: '1px solid #000', padding: '3px', backgroundColor: '#f9f9f9', fontSize: '10px' }}>OD</td>
                        <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px' }}>{Graduacion.AvOd || Graduacion.avOd || "-"}</td>
                        <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px' }}>{Graduacion.CvOd || Graduacion.cvOd || "-"}</td>
                      </tr>
                      <tr>
                        <td style={{ fontWeight: '800', textAlign: 'center', border: '1px solid #000', padding: '3px', backgroundColor: '#f9f9f9', fontSize: '10px' }}>OI</td>
                        <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px' }}>{Graduacion.AvOi || Graduacion.avOi || "-"}</td>
                        <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px' }}>{Graduacion.CvOi || Graduacion.cvOi || "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              
              {/* Mostrar DI y AO si existen */}
              {((Graduacion.DiData || Graduacion.diData) || (Graduacion.AoData || Graduacion.aoData)) && (
                <div style={{ marginTop: "6px", textAlign: "center", fontSize: '10px' }}>
                  {(Graduacion.DiData || Graduacion.diData) && (
                    <div style={{ marginBottom: "3px" }}>
                      <strong>DI:</strong> {Graduacion.DiData || Graduacion.diData}
                    </div>
                  )}
                  {(Graduacion.AoData || Graduacion.aoData) && (
                    <div style={{ marginBottom: "3px" }}>
                      <strong>AO:</strong> {Graduacion.AoData || Graduacion.aoData}
                    </div>
                  )}
                </div>
              )}
            </div>   
          ))  
        ) : (
          <>
            <h4 style={{ textAlign: "center", color: "lightgray" }}>
              
            </h4>
          </>
        )}
         <div style={{ textAlign: "center", marginTop: "8px", marginBottom: "6px", borderTop: '1px solid #000', paddingTop: '6px' }}>
           <strong style={{ fontSize: '12px' }}>Prescripción de Optometría</strong>
         </div>
         {/* Solo mostrar QR si hay HashId (pedido relacionado) */}
         {qrLink && qrLink.includes('HashId') && (
           <div style={{ textAlign: "center", marginTop: "6px" }}>
             <QRCode value={qrLink} size={90} />
           </div>
         )}
       </div>
     
      ):( 
        <>
        {
        NotaVenta.tipoTicketFis !== "Nota Simple" && (NotaVenta.saldoPendiente === 0 && NotaVenta.tipoTicketFis === "Comprobante") ? (
          <>
            <span style={{position: 'absolute', right: '0.2mm', top: '0.2mm', fontSize: '9px'}}>{NotaVenta.idFiscal.toString() + '-' + NotaVenta.sucursalNumber}</span>
          </>
        ) : null
      }
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: "8px", fontWeight: 'bold', fontSize: '13px', borderBottom: '1px solid #000', paddingBottom: '5px' }}>
        {
          (NotaVenta.tipoTicketFis && NotaVenta.tipoTicketFis.trim() === "Nota Simple")  ? (<strong>Nota de Venta</strong>) : (<strong>Comprobante</strong>)
        }
      </div>
      <div style={{display: 'flex', width: '100%', marginBottom: "8px", justifyContent: 'center'}}>
        <img
          src={logo}
          style={{width: "110px", height: 'auto' }}
        />
      </div>
      
      {/* Información Fiscal y Sucursal */}
      <div style={{ marginBottom: "8px", borderBottom: '1px dashed #ccc', paddingBottom: '6px' }}>
        <div style={{ marginBottom: "3px", textAlign:'center', fontSize: '11px'}}>
          <strong>Fecha:</strong> {fechaFormateada}
        </div>
        {
          NotaVenta.tipoTicketFis && NotaVenta.tipoTicketFis.trim() !== "Nota Simple" ? (
            <>
              {NotaVenta.rfc && (
                <div style={{ marginBottom: "2px", textAlign:'center', fontSize: '9px' }}>
                  <strong>RFC:</strong> {NotaVenta.rfc}
                </div>
              )}
              {NotaVenta.razonSocial && (
                <div style={{ marginBottom: "3px", textAlign:'center', fontSize: '9px', fontWeight: '700' }}>
                  {NotaVenta.razonSocial.toUpperCase()}
                </div>
              )}
            </>
          ) : null
        }
        <div style={{ marginBottom: "0px", textAlign:'center', padding: '0 1mm', fontSize: '9px', lineHeight: '1.2' }}>
          {NotaVenta.direccionSucursal}
        </div>
      </div>

      {/* Información del Cliente */}
      <div style={{ marginBottom: "8px", borderBottom: '1px dashed #ccc', paddingBottom: '6px' }}>
        <div style={{ marginBottom: "3px", textAlign:'center', border: '1px solid #000', padding:'3px 2px', borderRadius: '4px', backgroundColor: '#f9f9f9'}}>
          <strong style={{ fontSize: '11px' }}>Cliente:</strong><br /> 
          <span style={{textDecoration: 'underline', fontSize: '11px', fontWeight: 'bold'}}>{NotaVenta.nombreCliente}</span>
        </div>
        <div style={{ marginTop: "3px", marginBottom: "0px", textAlign:'center', fontSize: '10px'}}>
          {NotaVenta.telefono ? (
            <>
              <strong>Tel:</strong> {NotaVenta.telefono}
            </>
          ) : null}
        </div>
      </div>
    {/* Productos y Precios */}
    {(NotaVenta.armazon !== "" || NotaVenta.lente !== "" || NotaVenta.otro !== "") && (
      <div style={{ marginBottom: "8px", display: 'grid', width: '95%', margin: '0 auto', border: '1px solid #000', borderRadius: '4px', padding: '4px', backgroundColor: '#fafafa'}}>
        {NotaVenta.armazon !== "" && NotaVenta.armazon !== "0" && (
          <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom:'1px solid #ccc', paddingBottom: '3px', marginBottom: '3px', fontSize: '10px' }}>
            <span style={{ flex: 1 }}>{capitalize(NotaVenta.armazon)}</span>
            {NotaVenta.armazonImporte !== 0 && NotaVenta.armazonImporte !== "0" && <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>${formatNumber(NotaVenta.armazonImporte)}</span>}
          </div>
        )}
        {NotaVenta.lente !== "" && NotaVenta.lente !== "0" && (
          <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom:'1px solid #ccc', paddingBottom: '3px', marginBottom: '3px', fontSize: '10px' }}>
            <span style={{ flex: 1 }}>{capitalize(NotaVenta.lente)}</span>
            {NotaVenta.lenteImporte !== 0 && NotaVenta.lenteImporte !== "0" && <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>${formatNumber(NotaVenta.lenteImporte)}</span>}
          </div>
        )}
        {NotaVenta.otro !== "" && NotaVenta.otro !== "0" && (
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px' }}>
            <span style={{ flex: 1 }}>{capitalize(NotaVenta.otro)}</span>
            {NotaVenta.otroImporte !== 0 && NotaVenta.otroImporte !== "0" && <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>${formatNumber(NotaVenta.otroImporte)}</span>}
          </div>
        )}
      </div>
    )}

    {/* Total y Pagos */}
    <div style={{ marginBottom: "8px", width: '95%', margin: '0 auto', borderTop: '1px solid #000', paddingTop: '6px' }}>
      {/* Desglose fiscal para comprobantes (con facturación) */}
      {NotaVenta.tipoTicketFis !== "Nota Simple" && verPrecios === "flex" && NotaVenta.total && (
        <>
          {(() => {
            const total = parseFloat(NotaVenta.total) || 0;
            const subtotal = total / 1.16;
            const iva = total - subtotal;
            return (
              <>
                <div style={{ display: verPrecios, justifyContent: 'space-between', marginBottom: '3px', fontSize: '10px' }}>
                  <strong>Subtotal:</strong> ${formatNumber(subtotal.toFixed(2))}
                </div>
                <div style={{ display: verPrecios, justifyContent: 'space-between', marginBottom: '4px', fontSize: '10px' }}>
                  <strong>IVA (16%):</strong> ${formatNumber(iva.toFixed(2))}
                </div>
              </>
            );
          })()}
        </>
      )}
      <div style={{ display: verPrecios, justifyContent: 'space-between', marginBottom: '4px', fontSize: '11px', fontWeight: 'bold', borderTop: NotaVenta.tipoTicketFis !== "Nota Simple" ? '1px solid #ccc' : 'none', paddingTop: NotaVenta.tipoTicketFis !== "Nota Simple" ? '4px' : '0' }}>
        <strong>Total:</strong> <span style={{ textDecoration: 'underline', fontSize: '12px' }}>${formatNumber(NotaVenta.total)}</span>
      </div>
      {NotaVenta.tipoPago === "Anticipo" && (
        <div style={{ display: verPrecios, justifyContent: 'space-between', marginBottom: '3px', fontSize: '10px' }}>
          <strong>Anticipo:</strong> ${formatNumber(NotaVenta.anticipo) || 0}
        </div>
      )}
      <div style={{ display: verPrecios, justifyContent: 'space-between', marginBottom: '3px', fontSize: '10px' }}>
        <strong>Saldo Pendiente:</strong> ${formatNumber(NotaVenta.saldoPendiente)}
      </div>
      <div style={{ display: verPrecios, justifyContent: 'space-between', fontSize: '10px' }}>
        <strong>Forma de Pago:</strong> 
        <span>
          {UltimaTransaccion?.formaPago ? capitalize(UltimaTransaccion.formaPago) : capitalize(NotaVenta.formaPago)}
        </span>
      </div>
    </div>

      
      {
        NotaVenta.fechaEntregaPrevista !== "" ? (
        <div style={{display: "grid", marginBottom: "8px", width: '95%', margin: '0 auto', justifyContent: 'center', marginTop: "8px", textAlign: 'center', borderTop: '1px dashed #ccc', paddingTop: '6px'}}>
          <strong style={{fontSize: '10px', marginBottom: '3px'}}>Fecha de entrega:</strong> 
          <span style={{fontSize: '11px', border: '1px solid #000', padding:'3px 5px', borderRadius: '4px', backgroundColor: '#f9f9f9', display: 'inline-block'}}> 
            <span style={{textDecoration: 'underline', fontWeight: 'bold'}}>{fechaFormateadaEntrega.split(" ")[0]}</span> {fechaFormateadaEntrega.split(" ")[1]} {fechaFormateadaEntrega.split(" ")[2] } {fechaFormateadaEntrega.split(" ")[3]}
          </span>
        </div>
        ):null
      }
      <div style={{textAlign: "center", marginTop: "8px", marginBottom: "6px", fontSize: '11px', fontWeight: 'bold' }}>
        <strong>¡Gracias por su compra!</strong>
      </div>
      {Graduaciones.length > 0 ? (
          Graduaciones.map((Graduacion, index) => (
            <div style={{ marginTop: "8px", display: verGraduacion, marginBottom: '12px', borderTop: '1px solid #000', paddingTop: '8px'}} key={index}>
              <div style={{ textAlign: "center", marginBottom: "6px", fontSize: '12px', fontWeight: 'bold' }}>
                <strong style={{textDecoration: 'underline'}}>Datos Laboratorio {Graduaciones.length > 1 ? index + 1 : ''}</strong>
              </div>
              <div style={{textAlign: "center", marginBottom: "4px", fontSize: '11px', fontWeight: 'bold'}}>
                <strong>Graduación</strong>
              </div>
              <table style={{ width: '95%', margin: '0 auto', fontSize: '11px', fontWeight: '900', textAlign: 'center', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ border: '1px solid #000', padding: '2px', backgroundColor: '#f0f0f0', fontWeight: '800', fontSize: '10px' }}></th>
                    <th style={{ textAlign: 'center', fontWeight: '800', border: '1px solid #000', padding: '2px', backgroundColor: '#f0f0f0', fontSize: '10px' }}>ESF</th>
                    <th style={{ textAlign: 'center', fontWeight: '800', border: '1px solid #000', padding: '2px', backgroundColor: '#f0f0f0', fontSize: '10px' }}>CIL</th>
                    <th style={{ textAlign: 'center', fontWeight: '800', border: '1px solid #000', padding: '2px', backgroundColor: '#f0f0f0', fontSize: '10px' }}>EJE</th>
                    <th style={{ textAlign: 'center', fontWeight: '800', border: '1px solid #000', padding: '2px', backgroundColor: '#f0f0f0', fontSize: '10px' }}>ADD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ fontWeight: '800', border: '1px solid #000', padding: '3px', backgroundColor: '#f9f9f9', fontSize: '10px' }}>OD</td>
                    <td style={{border: '1px solid #000', padding: '3px'}}>{Graduacion.EsfOd > 0 ? "+" + Graduacion.EsfOd : Graduacion.EsfOd || "-"}</td>
                    <td style={{border: '1px solid #000', padding: '3px'}}>{Graduacion.CilOd > 0 ? "+" + Graduacion.CilOd : Graduacion.CilOd || "-"}</td>
                    <td style={{border: '1px solid #000', padding: '3px'}}>{Graduacion.EjeOd > 0 ? "+" + Graduacion.EjeOd : Graduacion.EjeOd || "-"}</td>
                    <td style={{border: '1px solid #000', padding: '3px'}}>{Graduacion.AddOd > 0 ? "+" + Graduacion.AddOd : Graduacion.AddOd || "-"}</td>
                  </tr>
                  <tr>
                    <td style={{ fontWeight: '800', border: '1px solid #000', padding: '3px', backgroundColor: '#f9f9f9', fontSize: '10px' }}>OI</td>
                    <td style={{border: '1px solid #000', padding: '3px'}}>{Graduacion.EsfOi > 0 ? "+" + Graduacion.EsfOi : Graduacion.EsfOi || "-"}</td>
                    <td style={{border: '1px solid #000', padding: '3px'}}>{Graduacion.CilOi > 0 ? "+" + Graduacion.CilOi : Graduacion.CilOi || "-"}</td>
                    <td style={{border: '1px solid #000', padding: '3px'}}>{Graduacion.EjeOi > 0 ? "+" + Graduacion.EjeOi : Graduacion.EjeOi || "-"}</td>
                    <td style={{border: '1px solid #000', padding: '3px'}}>{Graduacion.AddOi > 0 ? "+" + Graduacion.AddOi : Graduacion.AddOi || "-"}</td>
                  </tr>
                </tbody>
              </table>
              {/*Si existe Retinoscopia mostramos*/}
              {
                Graduacion.RetinosOd || Graduacion.RetinosOi ? (
                  <div style={{ marginTop: "6px" }}>
                    <div style={{ textAlign: "center", marginBottom: "3px", fontSize: '11px', fontWeight: 'bold' }}>
                      <strong>Retinoscopia</strong>
                    </div>
                    <table style={{ width: '60%', margin: '0 auto', fontSize: '11px', fontWeight: '800', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center', border: '1px solid #000', fontWeight: '800', padding: '2px', backgroundColor: '#f0f0f0', fontSize: '10px' }}>OD</th>
                          <th style={{ textAlign: 'center', border: '1px solid #000', fontWeight: '800', padding: '2px', backgroundColor: '#f0f0f0', fontSize: '10px' }}>OI</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px' }}>{Graduacion.RetinosOd > 0 ? "+" + Graduacion.RetinosOd : Graduacion.RetinosOd || "-"}</td>
                          <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px' }}>{Graduacion.RetinosOi > 0 ? "+" + Graduacion.RetinosOi : Graduacion.RetinosOi || "-"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ): null
              }


              {/*Si existe Queratometria mostramos*/}
              {
                Graduacion.QueratoOd1 || Graduacion.QueratoOd2 ||  Graduacion.QueratoOd3 || Graduacion.QueratoOi1 || Graduacion.QueratoOi2 || Graduacion.QueratoOi3 ? (
                  <div style={{ marginTop: "6px" }}>
                    <div style={{ textAlign: "center", marginBottom: "3px", fontSize: '11px', fontWeight: 'bold' }}>
                      <strong>Queratometría</strong>
                    </div>
                    <table style={{ width: '85%', margin: '0 auto', fontSize: '11px', fontWeight: '800', borderCollapse: 'collapse' }} className="tablaQuerato">
                      <tbody>
                        <tr>
                          <td style={{ fontWeight: '800', textAlign: 'center', border: '1px solid #000', padding: '3px', backgroundColor: '#f9f9f9', fontSize: '10px' }}>OD</td>
                          <td style={{ textAlign: 'right', border: '1px solid #000', padding: '3px', borderRight: 'none' }}>{Graduacion.QueratoOd1 > 0 ? "+" + Graduacion.QueratoOd1 : Graduacion.QueratoOd1 || "-"} /</td>
                          <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px', borderLeft: 'none', borderRight: 'none'}}>{Graduacion.QueratoOd2 > 0 ? "+" + Graduacion.QueratoOd2 : Graduacion.QueratoOd2 || "-"}</td>
                          <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px', borderLeft: 'none', borderRight: 'none' }}><strong>X</strong></td>
                          <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px', borderLeft: 'none' }}>{Graduacion.QueratoOd3 > 0 ? "+" + Graduacion.QueratoOd3 : Graduacion.QueratoOd3 || "-"}</td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: '800', textAlign: 'center', border: '1px solid #000', padding: '3px', backgroundColor: '#f9f9f9', fontSize: '10px' }}>OI</td>
                          <td style={{ textAlign: 'right', border: '1px solid #000', padding: '3px', borderRight: 'none' }}>{Graduacion.QueratoOi1 > 0 ? "+" + Graduacion.QueratoOi1 : Graduacion.QueratoOi1 || "-"} /</td>
                          <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px', borderLeft: 'none', borderRight: 'none' }}>{Graduacion.QueratoOi2 > 0 ? "+" + Graduacion.QueratoOi2 : Graduacion.QueratoOi2 || "-"}</td>
                          <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px', borderLeft: 'none', borderRight: 'none' }}><strong>X</strong></td>
                          <td style={{ textAlign: 'center', border: '1px solid #000', padding: '3px', borderLeft: 'none' }}>{Graduacion.QueratoOi3 > 0 ? "+" + Graduacion.QueratoOi3 : Graduacion.QueratoOi3 || "-"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ): null
              }

              {/* Información Adicional */}
              <div style={{ marginTop: "6px", fontSize: '10px' }}>
                {Graduacion.color && (
                  <div style={{ marginBottom: "3px", textAlign: 'center' }}>
                    <strong>Dep. / Emp:</strong> {Graduacion.color}
                  </div>
                )}
                {Graduacion.lenteContactoDes && (
                  <div style={{ marginBottom: "3px", textAlign: 'center' }}>
                    <strong>Lente Contacto:</strong> {Graduacion.lenteContactoDes}
                  </div>
                )}
              </div>
              
              {/* Observaciones */}
              {Graduacion.observaciones && (
                <div style={{ marginTop: "6px", borderTop: '1px dashed #ccc', paddingTop: '4px' }}>
                  <div style={{ marginBottom: "2px", textAlign: 'center', fontSize: '10px', fontWeight: 'bold' }}>
                    <strong>Observaciones:</strong>
                  </div>
                  <div style={{ marginBottom: "6px", width: '95%', textAlign: 'center', margin: '0 auto', fontSize: '10px', lineHeight: '1.3' }}>
                    {Graduacion.observaciones}
                  </div>
                </div>
              )}
            </div>   
          ))  
        ) : (
          <>
            <h4 style={{ textAlign: "center", color: "lightgray" }}>
              
            </h4>
          </>
        )}
        {qrLink && (
        <div style={{ textAlign: "center", marginTop: "8px", borderTop: '1px solid #000', paddingTop: '6px' }}>
          <QRCode value={qrLink} size={90} />
        </div>
      )}
        </>
      )}
      
    </div>
    
  );
};

export default NotaVentaView;
